import { mapState, mapActions } from "vuex";
import Empty from "../common/EmptyData.vue";
import JobNearby from "@/components/Nearby/JobNearby.vue"
import SwiperContainerH5 from './SwiperContainer-h5.vue'
import SelectedSvg from './SelectedSvg.vue'
import TabBar from './tabBar.vue'
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
export default {
  name: "CustomizedMulticolumnJobList",
  components: { Empty, SwiperContainerH5,JobNearby,SelectedSvg,TabBar },
  props: {
    pageConfig: {
      type: Object,
      default: () => { },
    },
    componentConfig: {
      type: Object,
      default: () => { },
    },
    goodJobZone: {
      // 好职专区用参数
      type: Object,
      default: () => { },
    },
    goodRank: {
      default: () => {
        return "";
      },
    },
    goodJobZoneLength: {
      type: Number,
    },
    componentType: {
      // 1:默认组件-右上刷新/链接 2:专区组件-更多加载职位
      type: Number,
      default: () => {
        return 1;
      },
    },
  },
  data() {
    return {
      urgentJobList: [],
      jobOrCompanyIdList: [], //下次请求列表带上次返回数组
      isShowDeliverys: true,// 是否展示一键投递, 初始化展示
      selectedJobIds: [], // 批量模式下被选中的投递卡片
      // 一键投递列表 排除网申和已投递
      delivarysJobList: [],
      pageNum: 1,
      pageSize: 4,
      totalPages: 0, //数据总页数
      loading: true,
      requestId: "",
      isFirstInit: false,
      mySwiper: null,
      row:2,
      tabList: [],
      tabType:'new',//职位上新（职位上新）：new,职位急招（增值服务）：fast, 职位更新（职位再发）：update
      openWechatStatus: false, // 是否开启微信通知
      appMessageState: false, // 是否开启消息通知
      isShowCustomMulticolumCom: false,  // 是否展示组件
    };
  },
  computed: {
    ...mapState(["commonStore", "resumeStore"]),
    nearbyPopShow: {
      get() {
        return this.commonStore.nearbyPopShow;
      },
      set() {},
    },
    jobNeedNearby: {
      get() {
        return this.componentConfig?.jobContentDTO?.showCondition==1 && !this.commonStore.lon;
      },
      set() {},
    },
    platform() {
      return this.commonStore.platform;
    },
    buttonColor() {
      return (
        this.pageConfig?.buttonColor
      );
    },
    isForPC(){
      return this.commonStore.isForPC
    },
    isLogin() {
      return this.$store.getters.isLogin;
    },
    jumpButtonConfig() {
      return this.componentConfig?.jumpButtonConfigDTO || {};
    },
    backgroundImage() {
      return this.pageConfig.moduleIconUrl;
    },
    needFilterJobs() {
      //是否当前组件需配置了推荐
      if (this.componentConfig?.recommendConfigDTO) {  // recommendConfigDTO.needFilterJobs =true 或 null 时需要进行首页去重,ecommendConfigDTO.needFilterJobs  =  false 不进行去重
        if( this.componentConfig?.recommendConfigDTO?.needFilterJobs || this.componentConfig?.recommendConfigDTO?.needFilterJobs == null){
          return true;
        }else {
          return true;
        }
      } else if (
        this.pageConfig?.recommendConfigDTO &&
        this.pageConfig?.recommendConfigDTO?.needFilterJobs
      ) {
        return true;
      } else {
        return false;
      }
    },
    currentTitleName(){
      return this.tabList[(this.$refs.tabBarWarp?.tagIndex || 0 )]?.title || '';
    }
  },
  watch: {
    "commonStore.currentAreaCode": {
      handler() {
        this.isFirstInit = false;
        this.pageNum = 1;
        this.loading = true;
        this.jobOrCompanyIdList = [];
        this.urgentJobList = [];
        if(this.pageConfig?.activityZoneId){
          this.iniTabList();
          this.getSubscribeMap();
        }
      },
      immediate: false,
    },
    "commonStore.wechatFollow": {
      handler (val) {
        this.openWechatStatus = val
      },
      immediate: true,
    }
  },
  async mounted() {
    this.iniTabList();
    this.selectedInit();
    if (this.isLogin && this.pageConfig?.activityZoneId) {
      // this.isShowCustomMulticolumCom = true
      await this.getSubscribeMap();
    }
  },
  methods: {
    iniTabList() {
      this.tabList = [
        {
          title: "新发布",
          type: "new",
          show: true,
        },
        {
          title: "急招",
          type: "fast",
          show: true,
        },
        {
          title: "职位要求/薪资变化",
          type: "update",
          show: true,
        },
      ]
    },
    handleTabChange(val){
      this.tabType = val.type;
      this.urgentJobList = [];
      this.delivarysJobList = [];
      this.loading = true;
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_tabs",
        moduleName: `${this.componentConfig?.type}`,
        contentName: val.title,
        bcopExrinfo: {
        pageCode: `YC|${this.$route.params.pageId || ''}|${this.componentConfig?.sort||'0'}|${this.componentConfig?.type || ''}|joblist|${this.componentConfig?.id || ''}|${this.pageConfig?.activityZoneId || ''}|${this.componentConfig?.jobContentDTO?.strategyId || ''}`,
        shortPageCode: `YC|${this.$route.params.pageId || ''}|${this.componentConfig?.sort||'0'}|${this.componentConfig?.type || ''}|joblist|${this.componentConfig?.id || ''}|${this.pageConfig?.activityZoneId || ''}|${this.componentConfig?.jobContentDTO?.strategyId || ''}`,
        },
      });
      this.selectedInit();
      this.queryJobList();
    },
    // 开启微信通知
    handleOpenWechat(){
      if( !this.commonStore.wechatFollow){ 
        this.$router.push({ path: "/scanCode" });
      }
    },
    // 开启消息通知
    handleOpenMsg() {
      this.$base.watchAppCover(this.appMessageSwitch);
      if (this.platform.includes("yjs")) {
        window.location.href =
          "yingjiesheng://home/openMessageAndSystemSettingPage";
      } else {
        if (this.commonStore.device == "harmonyApp") {
          window.harmony.jsAppBridgeOpenScheme(JSON.stringify({
            url: "qiancheng://home/show_message_setting_page"
          }));
        } else {
          window.location = "qiancheng://home/show_message_setting_page";
        }
      }
    },
    getWechatStatus() {
      const params = {
        fromDomain: this.platform.indexOf("yjs") > -1 ? "yjs" : "51job",
        accountId: this.commonStore?.accountId,
        activityId: this.pageConfig?.id, //活动id
      };
      const res = this.$api.activity.wechatQRCode(params);
      if (+res?.code == "0") {
        if (this.isLogin) {
          // follow用户有没关注公众号，false/true，accountId传值时 该字段才有意义。如果为true则表示用户已经关注过了，不需要显示右上角图标。
          this.openWechatStatus = res.data.follow;
        }
      }else{
        this.openWechatStatus = false;
      }
    },
    cityStr(jobAreaString) {
      //截取城市字段
      jobAreaString = jobAreaString.split("·")[0];
      return jobAreaString;
    },
    welfare(jobTags) {
      return jobTags.join(",");
    },
    ...mapActions("applyJobStore", ["applyJob", "batchApplyJob"]),
    buildJobShortExposureParams(item, index) {
      if (this.componentType == 2) {
        const property = JSON.parse(item.property);
        const val = `YC|${this.$route.params.pageId}|${this.componentConfig?.sort || '0'}|${this.componentConfig?.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}|${this.componentConfig?.jobContentDTO?.strategyId}`;

        property.pageCode = val;
        property.shortPageCode = val;

        item.property = JSON.stringify(property);
      }

      if (this.goodRank !== "") {
        return this.$base.getJobShortExposureParams(
          item,
          index,
          this.urgentJobList.length,
          {
            subContentRank: this.goodRank,
          }
        );
      } else {
        return this.$base.getJobShortExposureParams(
          item,
          index,
          this.urgentJobList.length
        );
      }
    },
    // 获取到订阅ID
    async getSubscribeMap() {
      let subscribed = false;
      this.isShowCustomMulticolumCom = false;
      if (this.platform.includes("App") || this.commonStore.device == "wechat") {
        let areaCode = (this.commonStore.currentAreaCode || this.commonStore?.intention?.expectArea) || '000000';
        areaCode = areaCode.indexOf(',') ? areaCode.split(',')[0] : areaCode;
        // 此处为什么没有从ActivityHeader中取，因为加载顺序，初次加载这个组件会拿不到返回值
        const res = await this.$api.activity.getBySubject({
          functionCode: this.$route.query?.funcCode
          ? this.$route.query?.funcCode
          : this.commonStore?.intention?.expectFunction || "0000",
          subjectId: this.pageConfig?.activityZoneId, //活动id
          areaCode: areaCode,
        });
        if (res.status === "1" && res.resultbody) {
          subscribed = res?.resultbody?.subscribed;
          if (subscribed) {
            if (await this.checkRequest() && this.componentConfig?.showLatestUpdates == 1) {
              this.isShowCustomMulticolumCom = true;
              this.queryJobList();
              this.appMessageSwitch();
            }
          }
        }
      }else if(process.env.NODE_ENV != "production"){
        subscribed = true
        if (subscribed) {
          if (await this.checkRequest() && this.componentConfig?.showLatestUpdates == 1) {
            this.isShowCustomMulticolumCom = true;
            this.queryJobList();
            this.appMessageSwitch();
          }
        }
      }
    },
    async checkRequest() { // 检测模块是否存在数据
      let list = [ ...this.tabList ];
      let tabCount = list.length;
      let type = '';

      for (let i=0; i<list.length; i++) {
        const tab = list[i]
        this.tabType = tab.type;

        const result = await this.queryJobList('readonly');
        if (!result.length) {
          list[i].show = false;
          tabCount--;
        } else {
          type = !type ? tab.type : type;
        }
      }
      
      this.tabList = list.filter(tab => {
        return tab.show;
      })
      
      this.tabType = type;
      return tabCount;
      
    },
    // 职位列表
    async queryJobList(type = "default") {
      let areaCode = (this.commonStore.currentAreaCode || this.commonStore?.intention?.expectArea) || '000000';
      areaCode = areaCode.indexOf(',') ? areaCode.split(',')[0] : areaCode;
      const params = {
        specialPageId: this.pageConfig?.activityZoneId,
        activityZoneQueryType: this.tabType || '',
        function: this.$route.query?.funcCode
          ? this.$route.query?.funcCode
          : this.commonStore.intention?.expectFunction || "",
        jobArea: areaCode,
        pageCode: `YC|${this.$route.params.pageId || ''}|${this.componentConfig?.sort||'0'}|${this.componentConfig?.type || ''}|joblist|${this.componentConfig?.id || ''}|${this.pageConfig?.activityZoneId || ''}|${this.componentConfig?.jobContentDTO?.strategyId || ''}`,
        shortPageCode: `YC|${this.$route.params.pageId || ''}|${this.componentConfig?.sort||'0'}|${this.componentConfig?.type || ''}|joblist|${this.componentConfig?.id || ''}|${this.pageConfig?.activityZoneId || ''}|${this.componentConfig?.jobContentDTO?.strategyId || ''}`,
        ...(((this.platform.includes("51job") && this.commonStore?.identityType == "在校生") || this.platform.includes("yjs")) &&  { springUserGroup: 1 }) 
      };
      const property = {
        pageCode: `YC|${this.$route.params.pageId || ''}|${this.componentConfig?.sort||'0'}|${this.componentConfig?.type || ''}|joblist|${this.componentConfig?.id || ''}|${this.pageConfig?.activityZoneId || ''}|${this.componentConfig?.jobContentDTO?.strategyId || ''}`,
        shortPageCode: `YC|${this.$route.params.pageId || ''}|${this.componentConfig?.sort||'0'}|${this.componentConfig?.type || ''}|joblist|${this.componentConfig?.id || ''}|${this.pageConfig?.activityZoneId || ''}|${this.componentConfig?.jobContentDTO?.strategyId || ''}`,
      };
      if(this.jobNeedNearby){
        this.loading = false;
        return
      }
      const res = await this.$api.activity.getCustomActivityJobList(params, {
        property,
      });
      // 首屏去重职位逻辑:请求完数据,加载下一个需要去重的组件
      // if (this.isFirstInit) {
      //   //首次加载数据
      //   this.isFirstInit = false;
      //   this.$base.setFilterJobIds(
      //     this.componentConfig.deWeightSort,
      //     res?.resultbody?.job?.items
      //   );
      // }else{
      //   this.$base.setFilterJobIds(
      //     '',
      //     []
      //   );
      // }
      if (type == "readonly") {
        let result = [];
        if (res?.status == "1") {
          result = res.resultbody.job?.items;
        }
        return result;
      }

      if (res?.status == "1") {
        this.loading = false;
        const {job,requestId} = res.resultbody
        const {items: jobInfoList, items: jobOrCompanyIdList} = job
        // const { jobOrCompanyIdList, jobInfoList } = res.resultbody;
        this.jobOrCompanyIdList = jobOrCompanyIdList;
        this.requestId = requestId;
        if (jobInfoList.length > 0) {
          this.totalPages = jobInfoList.totalCount;
          this.pageNum =
            this.pageNum < jobInfoList.totalCount ? this.pageNum + 1 : 1;
          this.urgentJobList = jobInfoList;
          this.delivarysJobList = this.urgentJobList.filter(
            (item) => !item.isFromXyx && !item.isApply && !item.isExpire
          );
          this.selectedJobIds = this.delivarysJobList.map(item=> item.jobId)
          this.isShowDeliverys = true;
        }

        this.$nextTick(() => {
          this.$exposure.sensorsExposure();
        });
      } else {
        this.urgentJobList = [];
        this.loading = false;
      }
    },
    // 获取年月日
    getCurrentDate(){
      // 获取当前日期
      const currentDate = new Date();
      // 获取年份
      const year = currentDate.getFullYear();
      // 获取月份（注意：月份从 0 开始计数，所以要加 1）
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      // 获取日
      const day = String(currentDate.getDate()).padStart(2, '0');

      // 拼接成所需格式
      const formattedDate = `${year}.${month}.${day}`;
      return formattedDate
    },
    // 获取是否开启消息通知的状态
    appMessageSwitch() {
      // 回调
      window.appMessage = (res) => {
        this.appMessageState = res.phoneSystemSwitch;
        console.log('=====开启消息通知',res)
      };
      if (this.commonStore.device == "androidApp") {
        this.appMessageState = window.android.jsAppBridgeGetPhoneSystemSwitch();
      }
      if (this.commonStore.device == "iosApp") {
        console.log('=====开启消息通知---iosApp')
        window.webkit.messageHandlers.model.postMessage([
          "jsAppBridgeGetPhoneSystemSwitch:",
          { callback: "appMessage" },
        ]);
      }
      console.log(this.appMessageState, "this.appMessageState");
    },
    clickJobCard(item, index,realIndex) {
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_joblist",
        moduleName: `${this.componentConfig?.sort || '0'}|${this.componentConfig?.type}`,
        contentName: this.componentConfig?.title,
        contentType: "职位",
        contentId: item.jobId,
        contentRank: `${index}`,
        bcopExrinfo: {
        pageCode: `YC|${this.$route.params.pageId || ''}|${this.componentConfig?.sort||'0'}|${this.componentConfig?.type || ''}|joblist|${this.componentConfig?.id || ''}|${this.pageConfig?.activityZoneId || ''}|${this.componentConfig?.jobContentDTO?.strategyId || ''}`,
        shortPageCode: `YC|${this.$route.params.pageId || ''}|${this.componentConfig?.sort||'0'}|${this.componentConfig?.type || ''}|joblist|${this.componentConfig?.id || ''}|${this.pageConfig?.activityZoneId || ''}|${this.componentConfig?.jobContentDTO?.strategyId || ''}`,
        subContentRank: `${this.goodRank}`,
        },
      });
      if (this.$base.checkLoginStatus(true)) {
        // 是否配置了职位大卡浏览
        if(this.pageConfig.showJobCard !== 1 && this.$store.getters.device !== 'pc' && this.$store.getters.device !== 'wechat'){
          console.log("自定义索引值",realIndex)
          this.showJbsCardPopup(`0-${realIndex}`);
        }else{
          this.$base.toJobDetail(item);
        }
      }
    },
    // 职位大卡展示
    showJbsCardPopup(index) {
      this.$emit("showJbsCardPopup",index,this.currentTitleName,this.urgentJobList,this.updateJobStatus);
    },
    updateJobStatus(itemObj){//同步大卡投递状态
      this.urgentJobList.some((item) => {
        if (item.jobId == itemObj.jobid) {
          console.log("投递成功之后的item",item,item.jobName)
          item.isApply = itemObj.isApplied;
          return true; // 相当于 break
        }
        return false; // 继续循环
      });
    },
    // 单投
    gotoDeliver(item, index = -1) {
      if (this.$base.checkLoginStatus(true) && !item.isApply) {
        if (item.isFromXyx) {
          //网申
          this.$base.toJobDetail(item);
        } else {
          // 单投
          const property = (item?.property && JSON.parse(item.property)) || {};
          const params = {
            item: { ...item, jobId: String(item.jobId) },
            property: {
              ...property,
              fromModule: "列表单投",
            },
            isShowToast: "0",
            onSuccess: () => {
              this.$emit("goQuestionSet", [item]);
              this.changeItemIsApply(item);
              this.$store.commit("setValueLocalStorage", {
                applyJobRefreshTasks:
                  this.$store.state.commonStore.applyJobRefreshTasks + 1,
              });
              this.updateJobList(index);
            },
          };
          this.applyJob(params);
        }
      }
    },
    handleChangeJob() {
    this.$sensors.track("$WebClick", {
      $element_id: "sensor_bcop_joblist2_more",
      moduleName: `${this.componentConfig?.sort || '0'}|${this.componentConfig?.type}`,
      contentName: this.componentConfig?.title,
      bcopExrinfo: {
        pagecode: `YC|${this.$route.params?.pageId}|${this.componentConfig?.sort || '0'}|${this.componentConfig?.type}|joblist|${this.componentConfig?.id}|${this.pageConfig?.activityZoneId}|${this.curItem?.strategyId}`,
      },
      contentType: "刷新职位",
  });
    this.loading = true;
    this.delivarysJobList = [];
    this.urgentJobList = [];
    this.queryJobList();
},
    // 单投成功后，列表更新已投递职位
    async updateJobList(index) {
      // 获取下一页数据
      const data = await this.queryJobList("readonly");
      let job = data.filter((item) => {
        return !item.isApply;
      });
      job = job.length ? job[0] : "";

      // 更新数据
      if (job) {
        if (!job.isFromXyx) {
          this.delivarysJobList.push(job);
        }
        this.urgentJobList.splice(index, 1, job);
      }
    },
    handleDeliverys() {
      const newDelivaryJobList = this.delivarysJobList.filter(item =>this.selectedJobIds.includes(item.jobId));
      if (newDelivaryJobList.length > 0) {
        if (this.$base.checkLoginStatus(true)) {
          if (!this.$store.state.commonStore.accountId) {
            this.$toast.fail("投递失败，请先完善简历");
            return false;
          }
          // 需过滤网申和已投递职位
          this.$toast.loading({
            message: "稍等片刻",
            forbidClick: true,
            className: "waiting-apply",
          });
          let item = newDelivaryJobList[0];
          const property = (item?.property && JSON.parse(item.property)) || {};
          this.batchApplyJob({
            jobList: newDelivaryJobList,
            property: {
              ...property,
              // pageCode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
              // shortPageCode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
              fromModule: "列表批投",
            },
            onResult: ({ allSuccess, arrSuccess, arrFail, resultArr }) => {
              console.log(
                "onResult",
                allSuccess,
                arrSuccess,
                arrFail,
                resultArr
              );

              if (allSuccess) {
                this.$toast.clear();
                this.$emit("goQuestionSet", newDelivaryJobList);
                setTimeout(() => {
                  this.urgentJobList = [];
                  this.handleChangeJob();
                }, 1000);
              } else {
                this.$toast.clear();
                this.$toast.fail("部分职位需要进入详情页单独投递~");
              }
              this.$store.commit("setValueLocalStorage", {
                applyJobRefreshTasks:
                  this.$store.state.commonStore.applyJobRefreshTasks + 1,
              });
            },
          });
          return;
        }
      }
    },
    // 投递成功后按钮展示已投递
    changeItemIsApply(item) {
      console.log(
        this.urgentJobList,
        item,
        item.jobId,
        this.urgentJobList.find((job) => job.jobId === item.jobId),
        "changeItemIsApply"
      );
      this.urgentJobList.find((job) => {
        console.log(job.jobId, item.jobId, "changeItemIsApply");
        return job.jobId === item.jobId;
      }).isApply = true;
    },
    initSwiper() {
      let self = this;
      this.mySwiper = new Swiper(`.swiper-container-${this.keyRandom}`, {
        observer: true,
        observeParents: true,
        slidesPerView: "auto",
        slidesPerGroup: 1, //明确分组为1
        spaceBetween: 0,
        loop: false, // 禁用循环模式
        resistanceRatio: 0.8, //默认开启惯性弹性效果
        on: {
          touchStart: function (event) {
            if (event.changedTouches && event.changedTouches.length > 0) {
              // 记录触点开始位置
              self.touchStartX = event.changedTouches[0].pageX;
            }
            if (this.isEnd) {
              if (!self.isLastTab) {
                this.params.resistanceRatio = 0.8; //开启惯性弹性效果
                this.update(); //更新swiper
              } else {
                this.params.resistanceRatio = 0; //关闭惯性弹性效果
                this.update(); //更新swiper
              }
            }
          },
          touchEnd: function (event) {
            if (event.changedTouches && event.changedTouches.length > 0) {
              // 记录触点结束位置
              self.touchEndX = event.changedTouches[0].pageX;

              // 判断是否滑动到最后一屏
              if (this.isEnd) {
                if (!self.isLastTab) {
                  // 查看下一专题文案展示埋点
                  self.$sensors.track("WidgetShow", {
                    $element_id: "sensor_25spring_hotandhaozhi_continueswipe",
                  });
                  // 计算滑动距离
                  const distance = self.touchStartX - self.touchEndX;
                  // 如果滑动距离超过 60px，执行跳转逻辑
                  if (distance > 60) {
                    self.viewMore(false);
                  }
                }
              }
            }
          },
        },
      });
    },
    selectedInit() {
      this.selectedJobIds = [];
      this.isShowDeliverys = true;
    },
    cancelDeliverys() {
      if (this.urgentJobList.length > 0) {
        this.isShowDeliverys = !this.isShowDeliverys;
        if (this.isShowDeliverys) {
          this.setAllSelected();
        } else {
          this.removeAllSelected();
        }
      }
    },
    setAllSelected() {
      // 一键投递过滤网申和已投递和已过期的
      if (this.urgentJobList.length > 0) {
        this.selectedJobIds = this.urgentJobList.filter(item => !item.isFromXyx && !item.isApply && !item.isExpire).map(item => item.jobId);
      } else {
        this.selectedJobIds = [];
      }
    },
    removeAllSelected() {
      this.selectedJobIds = [];
    },
    // 点击职位卡片左上角复选框
    changeItemSelected(item) {
      debugger
      // 已投递
      if (item.isApply) {
        this.$toast('您已投递该岗位了，无法选择批量投递哦');
        return;
      } else {
        // 一键投递
        if (item.isFromXyx) {
          //网申
          this.$toast('该职位不支持批量投递，请单独投递');
          return;
        } else {
          console.log('选中卡片');
        }
      }
      const isFromXyx = item.isFromXyx;
      const isApply = item.isApply;
      const isExpire = item.isExpire;
      if (!isFromXyx && !isApply && !isExpire) {
        const currentClickJobId = item.jobId;
        if (this.selectedJobIds.length > 0 && this.selectedJobIds.includes(currentClickJobId)) {
          this.selectedJobIds = this.selectedJobIds.filter(id => id != currentClickJobId);
        } else {
          this.selectedJobIds = [...this.selectedJobIds, currentClickJobId];
        }
        let allCanSelectList = this.urgentJobList.filter(item => !item.isFromXyx && !item.isApply && !item.isExpire).map(item => item.jobId);
        if (this.selectedJobIds.length === allCanSelectList.length) {
          this.isShowDeliverys = true;
        } else {
          this.isShowDeliverys = false;
        }

      }
    },
  },
};